module.exports = __webpack_public_path__ + "img/12t.prt.0741ad42.jpg";